import React from 'react';
import { Container } from 'react-bootstrap';
import { FooterNav } from '@ui/components/molecules';
import { FooterBars, SubFooter } from '@ui/components/atoms';
import { FooterLinks } from '@services/data';
import FooterStyles from './Footer.module.scss';

export const Footer: React.FC = () => {
  return (
    <div className={FooterStyles.footer}>
      <Container>
        <FooterNav links={FooterLinks} />
        <SubFooter />
        <FooterBars />
      </Container>
    </div>
  );
};
